// extracted by mini-css-extract-plugin
export var chartRow = "bK_fT";
export var chartSection = "bK_fV";
export var heading = "bK_dH";
export var legendSection = "bK_fW";
export var wrapper = "bK_bF";